<app-collapsible-container *ngIf="inContainer else notesSimple" name="notes" [expanded]="expanded">

  <h2 bannerLeft class="mb-0">Notes</h2>

  <div bannerRight>
    <button mat-button data-cy="add-note-button" (click)="toggleAddNote()">
      {{ addNoteOpen ? 'Cancel' : 'Add Note' }}
    </button>
  </div>

  <ng-container mainContent [ngTemplateOutlet]="notesSimple"></ng-container>

</app-collapsible-container>

<ng-template #notesSimple>
  <app-notes #notesComponent [borrowerId]="borrowerId" [borrowerName]="borrowerName" [dealId]="dealId"
    [dealNotes]="dealNotes$ | async" [draft]="draft" [expandStatus]='addNoteOpen' [hideHeader]='hideHeader'
    [inContainer]="inContainer" [lenderUserId]="lenderUserId" [notes]="notes$ | async" [useDealNotes]="useDealNotes"
    (addNote)="handleAddNote($event)" (deleteNote)="handleDeleteNote($event)" (editNote)="handleUpdateNote($event)"
    (enterEditNote)="handleEnterEditNote($event)" (saveDraft)="saveDraft($event)"></app-notes>
</ng-template>